// @flow
import React from 'react';
import cx from 'classnames';
import { getIn } from 'formik';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { Checkbox, FormControlLabel, FormHelperText } from '@material-ui/core';
import styles from './styles';

type Props = {
    checked?: boolean,
    classes?: Object,
    className?: string,
    disabled?: boolean,
    field: Object,
    form: Object,
    label?: string,
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom',
    type: 'checkbox',
};

const useStyles = makeStyles(styles, { name: 'FormikCheckbox' });

export default function FormikCheckbox(props: Props) {
    const {
        checked: checkedProp,
        classes: classesProp,
        className,
        disabled,
        field,
        form,
        label,
        labelPlacement,
        ...other
    } = props;

    const classes = useStyles(props);
    const { i18n, t } = useTranslation();

    const touched = getIn(form.touched, field.name);
    const error = getIn(form.errors, field.name);

    let errorMessage = null;
    if (touched && error) {
        if (typeof error === 'string') {
            errorMessage = i18n.exists(error) ? t(error) : error;
        } else if ('message' in error) {
            const { message, ...options } = error;
            errorMessage = i18n.exists(message) ? t(message, { ...options }) : message;
        }
    }

    const {
        root: rootClassName,
        wrapper: wrapperClassName,
        label: labelClassName,
        checkbox: checkboxClassName,
        errorMessage: errorClassName,
        ...otherClasses
    } = classes;

    const FormControlLabelProps = { disabled, label, labelPlacement };

    return (
        <div className={cx(rootClassName, className)}>
            <FormControlLabel
              classes={{
                  disabled: classes.disabled,
                  label: labelClassName,
                  root: wrapperClassName,
              }}
              control={(
                  <Checkbox
                    classes={{ root: checkboxClassName, ...otherClasses }}
                    checked={getIn(form.values, field.name)}
                    {...other}
                    {...field}
                  />
              )}
              {...FormControlLabelProps}
            />
            {errorMessage
                ? <FormHelperText error className={errorClassName}>{errorMessage}</FormHelperText>
                : null
            }
        </div>
    );
}
